import { jsx } from "react/jsx-runtime";
import { EditorParagraph } from "@contember/ui";
function ParagraphRenderer({ attributes, children, element }) {
  return (
    // TODO use BlockElement
    /* @__PURE__ */ jsx(EditorParagraph, { attributes, align: element.align, isNumbered: element.isNumbered, children })
  );
}
export {
  ParagraphRenderer
};
//# sourceMappingURL=ParagraphRenderer.js.map
